import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed } from 'vue';
import { useRouter } from 'vue-router/composables';
import { ModalHelper } from '@/helpers/modal-helper';
import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ThumborOptions } from '@/filters/thumbor';
import LabeledButton from './LabeledButton.vue';
import { isTitleInList } from '@/helpers/title-helper';
import { TitleListType } from '@/@types/graphql-types';

import { formatRuntime } from '@/helpers/title-helper';
import { useI18n } from '@/helpers/composables/useI18n';
import { faBookmark, faCheck, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';

import ReelsExp from '../index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelControlSidebar',
  props: {
    title: { default: {} }
  },
  emits: ["action"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'action', action: string, title: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: any };





const router = useRouter();

const imageUrl = computed(() => {
	// TODO [PictureComp] Refactor PictureComp to be able to use new url templating /poster/poster_id/{profile}/movie_name.{format}
	return Vue.filter('Thumbor')({
		url: posterUrl.value,
		imageType: 'poster',
	} as ThumborOptions);
});

const posterUrl = computed(() => props.title.content?.posterUrl ?? '');
const titleUrl = computed(() => props.title.content?.fullPath ?? '');

const likes = computed(() => props.title?.content?.interactions?.likelistAdditions || 0);
const dislikes = computed(() => props.title?.content?.interactions?.dislikelistAdditions || 0);

const { t } = useI18n();
const runtime = computed(() => {
	const runtimeValue = props.title.content.runtime!;
	const { translationKey, minutes, hours } = formatRuntime(runtimeValue);

	return t(translationKey, { minutes, hours }) as string;
});

const isInSeenList = computed(() => isTitleInList(TitleListType.CaughtUp, props.title));
const isInWatchlist = computed(() => isTitleInList(TitleListType.WatchNext, props.title));
const isInLikeList = computed(() => isTitleInList(TitleListType.Likelist, props.title));
const isInDislikeList = computed(() => isTitleInList(TitleListType.Dislikelist, props.title));

function goToTitleDetails() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'title_clicked',
		property: 'shorts_popular',
	});
	router.push({ path: titleUrl.value });
	ModalHelper.close();
}

function onClickout() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'clickout',
		property: 'shorts_popular',
	});
}

function handleClick(label: string, actionType: string) {
	ReelsExp.trackEvent({
		action: 'click',
		label: `${label}_add`,
		property: 'shorts_popular',
	});
	emits('action', actionType, props.title);
}

return { __sfc: true,props, emits, router, imageUrl, posterUrl, titleUrl, likes, dislikes, t, runtime, isInSeenList, isInWatchlist, isInLikeList, isInDislikeList, goToTitleDetails, onClickout, handleClick, WatchNowButtonNew, PictureComp, LabeledButton, faBookmark, faCheck, faThumbsUp, faThumbsDown }
}

})